import { LinearProgress } from "@mui/material";
import { FONT_SIZE_SMALL } from "constants/constants";
import styled from "styled-components/macro";

export function SnapshotsProgressStatus({
  snapshotsProgress,
}: {
  snapshotsProgress: {
    current: number;
    total: number;
  };
}) {
  return (
    <div>
      <Styles>
        <p>Snapshots progress:</p>
        <p>
          {snapshotsProgress.current} / {snapshotsProgress.total} snapshots{" "}
          {snapshotsProgress.current === snapshotsProgress.total
            ? "complete!"
            : "in progress"}
        </p>
      </Styles>
      <br />
      <LinearProgress
        variant="determinate"
        value={(snapshotsProgress.current / snapshotsProgress.total) * 100}
      />
    </div>
  );
}
const Styles = styled.div`
  display: flex;
  p:first-child {
    flex-grow: 1;
  }
  font-size: ${FONT_SIZE_SMALL};
`;
